import classes from './Cargo.module.sass'
import { Button } from '../../common/components/button/Button'
import { Sort } from '../../common/components/sort/Sort'
import { CargoList } from './components/cargoList/CargoList'
import { useCargo } from './hooks/useCargo'
import { Filters } from '../../common/components/filters/Filters'
import DateFilter from '../../common/components/listControl/dateFilter/DateFilter'
import { SearchSelectFilter } from '../../common/components/listControl/searchSelectFilter/SearchSelectFilter'
import Search from '../../common/components/listControl/search/Search'
import { Helmet } from 'react-helmet-async'
import { GMapForMarkers } from '../../common/components/maps/gMapForMarkers/GMapForMarkers'
import { selectCurrentUser } from '../../store/slices/currentUserSlice'
import { useSelector } from 'react-redux'
import { orderStatusOptions } from '../../common/utils/constants'
import { ListPageType } from '../../common/types/enums'
import TransportTypeSelector from '../../common/components/listControl/transportTypeSelector/TransportTypeSelector'
import { CargoSelector } from '../../common/components/listControl/cargoSelector/CargoSelector'

export const Cargo = () => {
  const {
    list,
    addAction,
    createCitySelectList,
    onChangeSearch,
    onChangeRange,
    onChangeSort,
    clearSearch,
    sortOptions,
    setCity,
    sort,
    search,
    filtersDirty,
    range,
    cityId,
    clearFilters,
    activateFilters,
    setStatus,
    status,
    toggleSelected,
    pageType,
    loading,
    types,
    setTypes,
    filtersChanged,
  } = useCargo()

  const currentUser = useSelector(selectCurrentUser)

  return (
    <div className={classes.Container}>
      <Helmet>
        <title>logid - грузы</title>
        <meta
          name="description"
          content="Найти загрузку для транспорта и курьерские заказы по всей России"
        />
      </Helmet>
      <div className={classes.Header}>
        {pageType === ListPageType.MY
          ? 'Мои грузы'
          : pageType === ListPageType.SELECTED
          ? 'Избранные грузы'
          : 'Грузы'}
      </div>
      <div className={classes.ButtonAndFilters}>
        <div className={classes.ButtonContainer}>
          <Button text="Добавить груз" onClick={addAction} />
        </div>
        <div className={classes.SearchFilterSortContainer}>
          <Filters
            clearFilters={clearFilters}
            filtersDirty={filtersDirty}
            activateFilters={activateFilters}
            filtersChanged={filtersChanged}
          >
            <DateFilter onChange={onChangeRange} range={range} />
            <SearchSelectFilter
              visibleOptionsLength={10}
              emptyPlaceHolder="Начните ввод, чтобы найти и выбрать город"
              options={createCitySelectList()}
              onChangeHandler={setCity}
              value={cityId}
              placeholder={createCitySelectList().length > 0 ? 'Все города' : 'Нет городов'}
            />

            {currentUser ? (
              <SearchSelectFilter
                emptyPlaceHolder="Начните ввод, чтобы найти и выбрать статус"
                options={[
                  {
                    id: '',
                    name: 'Все статусы',
                    label: 'Все статусы',
                    value: '',
                  },
                  ...orderStatusOptions,
                ]}
                onChangeHandler={setStatus}
                value={status}
                placeholder={'Все статусы'}
                visibleOptionsLength={9}
              />
            ) : (
              <></>
            )}

            <>
              <CargoSelector topData={types} setTopData={setTypes} />

              <TransportTypeSelector multiple topData={types} setTopData={setTypes} />
            </>
          </Filters>
          <Sort
            options={sortOptions}
            value={sort}
            onChange={onChangeSort}
            activateFilters={activateFilters}
          />
          <div className={classes.SearchContainer}>
            <Search
              onChange={onChangeSearch}
              clear={clearSearch}
              value={search}
              placeHolder="Введите наименование или описание"
            />
          </div>
        </div>
      </div>
      {list.data.length > 0 ? (
        <CargoList list={list.data} toggleSelected={toggleSelected} loading={loading} />
      ) : !filtersDirty ? (
        <div className={classes.Message}>Грузы не найдены, проверьте фильтры</div>
      ) : (
        <div className={classes.Message}>Нет грузов</div>
      )}

      <GMapForMarkers list={list.data} />
    </div>
  )
}
